module.exports = __webpack_public_path__ + "img/3.1f92f190.jpg";